import React from "react";
import { Accordion, Button, Card, Form } from "react-bootstrap";
import ValidationHelper from "../../../../../../helpers/ValidationHelper";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import MarkDownEditor from "../../../../../../components/markdownEditor/MarkDownEditor";
import Switch from "react-switch";
import BaseDialog from "../../../../../../components/dialogs/baseDialog/BaseDialog";


//TODO: Code duplication create / update
class CreateHardwareDialog extends React.Component {
  constructor(props) {
    super(props);

    this.validationDefinition = {
      product: {
        defaultValue: "",
        rule: (value) => ValidationHelper.isString(value) && value.length > 3
      },
      tags: {
        defaultValue: [],
        rule: ValidationHelper.isStringArray
      },
      tpmVersion: {
        defaultValue: "",
        rule: ValidationHelper.isTPMVersion
      },
      testedOS: {
        defaultValue: "",
        rule: ValidationHelper.isTestedOS
      },
      isTPMReady: {
        defaultValue: false,
        initValid: true,
        rule: ValidationHelper.isBoolean
      },
      isBootReady: {
        defaultValue: false,
        initValid: true,
        rule: ValidationHelper.isBoolean
      },
      isBootable: {
        defaultValue: false,
        initValid: true,
        rule: ValidationHelper.isBoolean
      },
      isRunningStable: {
        defaultValue: false,
        initValid: true,
        rule: ValidationHelper.isBoolean
      },
      remarks: {
        defaultValue: ValidationHelper.getDefaultValueExtendedDescription(),
        initValid: false,
        rule: ValidationHelper.isExtendedDescription
      }
    };

    this.state = {
      validation: ValidationHelper.getValidation(this.validationDefinition)
    };

    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onHide = this.onHide.bind(this);
  }

  handleChange(event) {
    this.setState({
      validation: ValidationHelper.update(event, this.state.validation)
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show) {
      this.setState({
        validation: ValidationHelper.getValidation(this.validationDefinition)
      });
    }
  }

  onHide() {
    this.props.onHide(ValidationHelper.hasChanged(this.state.validation));
  }

  onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      this.props.onSubmit(validatedData);
    }
  }

  render() {
    const { t } = this.props;
    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.onHide}
        rightButtonCallback={this.onSubmit}
        title={t("Hardware.Tabs.Index.CreateModalTitle")}
        rightButtonText={t("Hardware.Tabs.Index.Modal.Form.Create")}
        leftButtonText={t("DialogCancel")}
        rightButtonVariant="green"
        leftButtonVariant="black"
        leftButtonCallback={this.onHide}
        dialogApiError={this.props.dialogApiError}
        rightButtonDisabled={!this.state.validation._isValid}
        body={(<Form onSubmit={this.onSubmit}>
          <Accordion defaultActiveKey="0">
            <Card>
              <Card.Header className="pt-0 pb-0 pl-2 pr-2">
                <Accordion.Toggle
                  as={Button}
                  variant="link"
                  className="acc-link"
                  eventKey="0"
                >
                  <FontAwesomeIcon
                    icon={faExclamationCircle}
                    className={
                      this.state.validation.product.isValid &&
                      this.state.validation.tpmVersion.isValid
                        ? "display-none"
                        : "mr-2 color-red"
                    }
                  />
                  <span>{t("Hardware.Tabs.Index.Modal.Form.ToggleBasic")}</span>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  <Form.Group controlId="formProduct">
                    <Form.Label>
                      {t("Hardware.Tabs.Index.Modal.Form.Product")}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="product"
                      placeholder={t(
                        "Hardware.Tabs.Index.Modal.Form.ProductPlaceholder"
                      )}
                      value={this.state.validation.product.value}
                      isInvalid={!this.state.validation.product.isValid}
                      onChange={event => {
                        this.handleChange(event);
                        const tags = Array.from(new Set(event.target.value.toLowerCase()
                          .replace(/[()_\-]/g, " ")
                          .split(" ")
                          .filter(tag => (tag.length > 2 || /^[0-9]{1,}$/.test(tag)) && tag !== "0000000000000000")
                          .flatMap(tag => {
                            const matches = tag.match(/[0-9]*[,.][0-9]*/g);
                            return matches !== null ?
                              [matches[0], tag, tag.replace(matches[0], "")] : tag;
                          })));
                        this.handleChange({ target: { name: "tags", value: tags } });
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {t("Hardware.Tabs.Index.Modal.Form.ValidationError.Product")}
                    </Form.Control.Feedback>
                    <p className="tagList mt-1">
                      {t("Hardware.Tabs.Index.Modal.Form.Tags")}: {this.state.validation.tags.value.join(", ")}
                    </p>
                  </Form.Group>
                  <Form.Group controlId="formTPMVersion">
                    <Form.Label>
                      {t("Hardware.Tabs.Index.Modal.Form.TPMVersion")}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="tpmVersion"
                      placeholder={t(
                        "Hardware.Tabs.Index.Modal.Form.TPMVersionPlaceholder"
                      )}
                      value={this.state.validation.tpmVersion.value}
                      isInvalid={!this.state.validation.tpmVersion.isValid}
                      onChange={this.handleChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      {t("Hardware.Tabs.Index.Modal.Form.ValidationError.TPMVersion")}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="formTestedOS">
                    <Form.Label>
                      {t("Hardware.Tabs.Index.Modal.Form.TestedOS")}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="testedOS"
                      placeholder={t(
                        "Hardware.Tabs.Index.Modal.Form.TestedOSPlaceholder"
                      )}
                      value={this.state.validation.testedOS.value}
                      isInvalid={!this.state.validation.testedOS.isValid}
                      onChange={this.handleChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      {t("Hardware.Tabs.Index.Modal.Form.ValidationError.TestedOS")}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="formSwitchIsTPMReady">
                    <Switch
                      className="isPublishedSwitch"
                      onColor="#54BF8D"
                      checked={this.state.validation.isTPMReady.value}
                      onChange={state => {
                        this.handleChange({
                          target: {
                            name: "isTPMReady",
                            value: state
                          }
                        });
                      }}
                      height={18}
                      width={40}
                    />
                    <Form.Label>
                      {t("Hardware.Tabs.Index.Modal.Form.IsTPMReady")}
                    </Form.Label>
                    <Form.Control
                      type="hidden"
                      isInvalid={!this.state.validation.isTPMReady.isValid}
                    />
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "Hardware.Tabs.Index.Modal.Form.ValidationError.IsTPMReady"
                      )}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="formSwitchIsBootReady">
                    <Switch
                      className="isPublishedSwitch"
                      onColor="#54BF8D"
                      checked={this.state.validation.isBootReady.value}
                      onChange={state => {
                        this.handleChange({
                          target: {
                            name: "isBootReady",
                            value: state
                          }
                        });
                      }}
                      height={18}
                      width={40}
                    />
                    <Form.Label>
                      {t("Hardware.Tabs.Index.Modal.Form.IsBootReady")}
                    </Form.Label>
                    <Form.Control
                      type="hidden"
                      isInvalid={!this.state.validation.isBootReady.isValid}
                    />
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "Hardware.Tabs.Index.Modal.Form.ValidationError.IsBootReady"
                      )}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="formSwitchIsBootable">
                    <Switch
                      className="isPublishedSwitch"
                      onColor="#54BF8D"
                      checked={this.state.validation.isBootable.value}
                      onChange={state => {
                        this.handleChange({
                          target: {
                            name: "isBootable",
                            value: state
                          }
                        });
                      }}
                      height={18}
                      width={40}
                    />
                    <Form.Label>
                      {t("Hardware.Tabs.Index.Modal.Form.IsBootable")}
                    </Form.Label>
                    <Form.Control
                      type="hidden"
                      isInvalid={!this.state.validation.isBootable.isValid}
                    />
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "Hardware.Tabs.Index.Modal.Form.ValidationError.IsBootable"
                      )}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="formSwitchIsRunningStable">
                    <Switch
                      className="isPublishedSwitch"
                      onColor="#54BF8D"
                      checked={this.state.validation.isRunningStable.value}
                      onChange={state => {
                        this.handleChange({
                          target: {
                            name: "isRunningStable",
                            value: state
                          }
                        });
                      }}
                      height={18}
                      width={40}
                    />
                    <Form.Label>
                      {t("Hardware.Tabs.Index.Modal.Form.IsRunningStable")}
                    </Form.Label>
                    <Form.Control
                      type="hidden"
                      isInvalid={!this.state.validation.isRunningStable.isValid}
                    />
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "Hardware.Tabs.Index.Modal.Form.ValidationError.IsRunningStable"
                      )}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Card.Header className="pt-0 pb-0 pl-2 pr-2">
                <Accordion.Toggle
                  as={Button}
                  variant="link"
                  className="acc-link"
                  eventKey="1"
                >
                  <FontAwesomeIcon
                    icon={faExclamationCircle}
                    className={
                      this.state.validation.remarks.isValid
                        ? "display-none"
                        : "mr-2 color-red"
                    }
                  />
                  <span>{t("Hardware.Tabs.Index.Modal.Form.ToggleRemarks")}</span>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="1">
                <Card.Body>
                  <MarkDownEditor
                    onChange={value =>
                      this.handleChange({
                        target: {
                          name: "remarks",
                          value: value
                        }
                      })
                    }
                  />
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </Form>)}
      />
    );
  }
}

export default withTranslation()(CreateHardwareDialog);
